import content from "./content.json";

export const RARE_PLANT_TOTAL_COUNT = Object.keys(content.rarePlants).length;
export const BIOMEMASTER_UNLOCK_COUNT = RARE_PLANT_TOTAL_COUNT;
